export interface IAppState {
    carouselVisible: boolean;
}

export const initialAppState: IAppState = {
    carouselVisible: false
}